<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hA0l4d/tc-custom/9781614233107.jpg?1688954038359" alt="This image is the cover for the book Newburyport and the Civil War, Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Newburyport and the Civil War, Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p>The smoke of cannon fire and the sound of rifles were not seen or heard in Newburyport, Massachusetts during the Civil War yet it was an all too familiar experience for many of its inhabitants. Local author William Hallett describes in thrilling detail the lives and deeds of those from the Clipper City that served both Union and Confederate causes. From the abolitionist preaching of William Lloyd Garrison to the heroism of Albert W. Bartlett, with naval warfare, including the construction of the U.S.S. Marblehead, and political intrigue in between, Newburyport left its mark on the Civil War. With stories of valor both on the battlefield and the home front, Hallett presents the history and legacy of Newburyport in Civil War.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Hallett
      </h2>
      
      <p class="authorDescription body article">A former radio announcer turned writer, William Hallett is a twelfth-generation descendant of a first settler of Newbury, Nicholas Noyes. Always a fan of American history, Bill lived in Maryland near Pennsylvania as a youth and by his twenties had acquired an interest in Civil War history, which is so prevalent in that region. In 1994, he returned to New England and not long after became involved in the Civil War Roundtable of New Hampshire. He led that group as president for ten years and as vice-president for two. He also joined the Civil War Roundtable of the Merrimack and served on the board. During the same time, he was introduced to the world of reenacting, with his first occasion being an encampment on the grounds of Gettysburg National Military Park in June 1994. Determined to keep alive the memory of the people and events of this most crucial time in history, Bill has decided to create this book hoping to spotlight Newburyport's place in Civil War history. Bill lives in Newburyport with his wife, Elizabeth. The couple periodically hosts Footsteps of Heroes: Civil War Walking Tour of Newburyport.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63c09bb4